
import React from "react";

const CheckMarkRound = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M7.25 7.25a15.556 15.556 0 1 1 22 22 15.556 15.556 0 0 1-22-22Zm11-1.444a12.444 12.444 0 1 0 0 24.888 12.444 12.444 0 0 0 0-24.888Z"
            clipRule="evenodd"
        />
        <path
            fill={fill}
            d="M21.94 13.94a1.5 1.5 0 1 1 2.12 2.12l-6 6a1.5 1.5 0 0 1-2.12 0l-3-3a1.5 1.5 0 0 1 2.12-2.12L17 18.878l4.94-4.94Z"
        />
    </svg>
);

export default CheckMarkRound;